<template>
  <van-overlay :show="show" style="z-index: 1111">
    <div style="display: flex;align-items: center;justify-content: center;height: 100%;">
      <van-loading size="24px" vertical color="#ffffff">{{title}}</van-loading>
    </div>
  </van-overlay>
</template>
<script type="text/ecmascript-6">
  import Vue from 'vue';
  import {
    Loading,
    Overlay
  } from 'vant';
  Vue.use(Loading).use(Overlay)

  export default {
    props: {
      show: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '加载中...'
      }
    }
  }

</script>
<style>
  .van-overlay {
    z-index: 1111 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/loading/loading.vue